import styled from "styled-components";

export const Container = styled.div`
  height: 72vh;
  width: 430px;
  overflow-y: auto;
`;

export const ContainerBody = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 80%;
`;

export const ContainerInputs = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 12px;
  margin-bottom: 22px;
`;
export const ContainerInputsExternal = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  gap: 12px;
  margin-bottom: 22px;

  > div {
    width: 100%;
  }
`;

export const ContainerSwitch = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 25px;
`;

export const ContainerRadioGroup = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 22px;
`;

export const RadioBoxWrapper = styled.div`
  margin-top: 8px;
  padding: 0 12px;
  border: 2px dashed #d1dbe3;
  border-radius: 4px;
`;

export const LabelRadio = styled.label`
  font-size: 14px;
  font-weight: 500;
  color: #666666;
`;
